import { BaseService } from "./../base";
export class CategoryService extends BaseService {
  static get entity() {
    return "category";
  }
  static get name() {
    return "category";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async getCategories() {
    let result;
    let itemssubc = [];
    let telePadre = [];
    let responseCategory = await this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
    responseCategory.forEach((value) => {
      value.subcatgories.forEach((valor) => {
        itemssubc.push({ id: valor.id, label: valor.name + " (" + valor.id + ")", auge: valor.auge });
      });

      telePadre.push({
        id: value.id,
        label: value.name + " (" + value.id + ")",
        auge: value.auge,
        children: itemssubc,
      });
      itemssubc = [];
    });
    result = telePadre;
    return result;
    // await resource
    //     .get(`api/${window.getApiUrlEntity(localStorage.getItem('perfil'))}category/all`)
    //     .then(
    //         (response) => {
    //             console.log(response);
    //             response.body.category.forEach((value) => {
    //                 value.subcatgories.forEach((valor) => {
    //                     itemssubc.push({ id: valor.id, label: valor.name });
    //                 });

    //                 telePadre.push({
    //                     id: value.id,
    //                     label: value.name + " (" + value.id + ")",
    //                     children: itemssubc,
    //                 });
    //                 itemssubc = [];
    //             });
    //         },
    //         (response) => {
    //             console.log(response);
    //         }
    //     );
  }

  static async getByCategoryOrSubcategory(code) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_categories_or_subcategories/${code}`, "data");
  }
  /**
     *     
     * 
    let result;
    let itemssubc = [];
    let telePadre = [];
    await resource
        .get(`api/${window.getApiUrlEntity(localStorage.getItem('perfil'))}category/all`)
        .then(
            (response) => {
                console.log(response);
                response.body.category.forEach((value) => {
                  value.subcatgories.forEach((valor) => {
                    itemssubc.push({ id: valor.id, label: valor.name });
                  });
    
                  telePadre.push({
                    id: value.id,
                    label: value.name + " (" + value.id + ")",
                    children: itemssubc,
                  });
                  itemssubc = [];
                });
              },
            (response) => {
                console.log(response);
            }
        );
    result = telePadre;
    return result;
     */
}
